import { styled } from "@mui/system";
import { Grid, Box, Typography } from "@mui/material";

import { ArrayRemoveButton } from "../../../Buttons/ArrayRemoveButton";

export const FlexContainer = styled(Grid)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0"
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const AddMoreButton = styled("div")(({ theme }) => ({
  backgroundColor: "none !important",
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const RemoveButton = styled(ArrayRemoveButton)(({ theme }) => ({
  position: "relative",
  right: "auto",
  left: "auto",
  top: "auto",
  float: "right",
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const Label = styled(Typography)(({ theme }) => ({
  variant: "body1"
}));
